import { render, staticRenderFns } from "./figureSellRecentList.vue?vue&type=template&id=4a40a6f4&scoped=true&"
import script from "./figureSellRecentList.vue?vue&type=script&lang=js&"
export * from "./figureSellRecentList.vue?vue&type=script&lang=js&"
import style0 from "./figureSellRecentList.vue?vue&type=style&index=0&id=4a40a6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a40a6f4",
  null
  
)

export default component.exports